
import { Field,reduxForm, initialize } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactGA from 'react-ga';
import { motion, AnimatePresence } from 'framer-motion';

import * as homeActions from '../actions/homeActions';
import { PaymentInputsWrapper, usePaymentInputs, PaymentInputsContainer } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import LoadingOverlay from '../components/LoadingOverlay';
import { css } from 'styled-components';






class PaymentDetailForm extends React.Component{
    constructor(props){
        super(props);

        this.state = {
          cookiesAccepted: false,
        };
    }
    
    componentDidMount(){
        window.addEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: true });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: false });
        });
    }


    render(){
        const {
          isLoading,
          handleChangeCardNumber,
          handleChangeExpiryDate,
          handleChangeCVC, 
          isFetching, 
          loggingIn,
          isSubmitting
        }  = this.props;

        return (
            <div className="row">
                <LoadingOverlay loading={isLoading} spinnerStyle={{ top: "20%" }}>
                    <form>
                    <div className="account-card b-rad">
                        <div className="row header">
                            <div className="col-12">
                                <label className="card-title mb-0">Payment Details</label>
                            </div>
                            <hr/>
                        </div>
                        <AnimatePresence>
                          {
                            !this.props.paymentDetail.validated && 
                            this.props.authentication.loggedIn &&
                            !isFetching &&
                            !isSubmitting &&
                            !loggingIn && (
                          <motion.div
                            className="row"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0}}>
                            <div className="col-12 col-md-12">
                              <p className="text-black-50 bg-warning bg-warning__icon">
                                {this.props.paymentDetail.data.paymentType != 'SEPA' && (
                                  <span>Looks like you don't have any payment cards saved to your account yet. Please enter your card details to continue. </span>
                                )}
                                {this.props.paymentDetail.error && (
                                  <span>{this.props.paymentDetail.error.message}</span>
                                )}
                              </p>
                            </div>
                          </motion.div>
                        )}
                        </AnimatePresence>
                        
                        <div className="row text-center">
                          {this.props.paymentDetail.data.paymentType != 'SEPA' ? (
                            <PaymentInputsContainer>
                              {({
                                getCardNumberProps, 
                                getExpiryDateProps, 
                                getCVCProps, 
                                getCardImageProps, 
                                wrapperProps }) => (
                                <PaymentInputsWrapper
                                  {...wrapperProps}
                                  styles={{
                                    fieldWrapper: {
                                      base: css`
                                        margin-bottom: 1rem;
                                        padding: 0 15px;
                                        width: 100%;
                                      `
                                    },
                                    inputWrapper: {
                                      errored: css`
                                        border-color: maroon;
                                      `
                                    },
                                    input: {
                                      errored: css`
                                        color: maroon;
                                      `,
                                      cardNumber: css`
                                        min-width: 11rem;
                                        width: 50%;
                                        height: 36px;
                                        border-top-color: inherit;
                                        border-top-style: solid;
                                        border-top-width: 1px;

                                        border-right-color: inherit;
                                        border-right-style: solid;
                                        border-right-width: 1px;

                                        border-bottom-color: inherit;
                                        border-bottom-style: solid;
                                        border-bottom-width: 1px;

                                      `,
                                      expiryDate: css`
                                        min-width: 5rem;
                                        width: 25%;
                                        height: 36px;
                                        border-top-color: inherit;
                                        border-top-style: solid;
                                        border-top-width: 1px;

                                        border-right-color: inherit;
                                        border-right-style: solid;
                                        border-right-width: 1px;

                                        border-bottom-color: inherit;
                                        border-bottom-style: solid;
                                        border-bottom-width: 1px;
                                      `,
                                      cvc: css`
                                        width: 25%;
                                        min-width: 4rem;
                                        border-top-color: inherit;
                                        border-top-style: solid;
                                        border-top-width: 1px;
                                        border-bottom-color: inherit;
                                        border-bottom-style: solid;
                                        border-bottom-width: 1px;
                                        height: 36px;
                                      `
                                    },
                                    errorText: {
                                      base: css`
                                        color: maroon;
                                      `
                                    }
                                  }}
                                >
                                  <svg {...getCardImageProps({ images })} />
                                  <input {...getCardNumberProps({ onChange: handleChangeCardNumber })} disabled={this.props.paymentDetail.validated} value={this.props.paymentDetail.cardNumber}/>
                                  <input {...getExpiryDateProps({ onChange: handleChangeExpiryDate })} disabled={this.props.paymentDetail.validated} value={this.props.paymentDetail.expiryDate}/>
                                  {
                                    !this.props.paymentDetail.validated?<input {...getCVCProps({ onChange: handleChangeCVC  })} value={this.props.paymentDetail.cvc}/>:null
                                  }
                                </PaymentInputsWrapper>
                              )}
                            </PaymentInputsContainer>
                          ):
                          (
                            <div className="mx-3">
                              <div className="account-card account-card__easyTrip">
                                <div className="card-body">
                                  <div className="card-text">You will be charged through your EasyTrip account</div>

                                </div>
                              </div>
                            </div>
                          )
                        }
                        </div>
                      </div>
                    </form>
                </LoadingOverlay>
            </div>
          );
          
    }
    
}

PaymentDetailForm.propTypes = {
    isLoading: PropTypes.bool,
    paymentDetail:PropTypes.object,
    handleChangeCardNumber:PropTypes.func,
    handleChangeExpiryDate:PropTypes.func,
    handleChangeCVC:PropTypes.func,
    authentication:PropTypes.object


};
function mapStateToProps(state) {
    return {
      paymentDetail: state.paymentDetail,
      authentication:state.authentication
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(homeActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'paymentDetailForm',
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
          ReactGA.event({
            category: 'service',
            action: 'payment'
          });
        }
    }
})(PaymentDetailForm));





// WEBPACK FOOTER //
// ./src/forms/PaymentDetailForm.jsx